<template>
  <div :class="getClass" :style="{ marginLeft: margin }">
    <div class="search-location">
    </div>
    <div class="search-dates">
      <div class="search-container">
        <div class="search-label">
          <span>Select dates below for booking a trip</span>
        </div>
        <div class="search-textbox">
          <img src="@/assets/icons/calender.svg" alt="" />
          <date-range-picker
            :opens="'center'"
            v-model="dateRange"
            @finish-selection="onFinishSelection"
            @start-selection="onStartSelection"
            :min-date="getMinDate"
            :date-format="dateFormat"
            :auto-apply="false"
            :ranges="true"
            :linked-calendars="false"
            single-date-picker="range"
            @change-month="onChangeMonth"
            @toggle="onToggle"
          >
            <template #date="data">
              <span class="small" v-html="formatDate(data.date)"> </span>
            </template>
            <template #ranges>
              <div class="ranges"></div>
            </template>
            <template #input="picker">
              {{ formatFullDate("start", picker) }}
            </template>
            <div
              slot="footer"
              slot-scope="data"
              class="slot pa-4 d-flex justify-end"
            >
              <div>
                <v-btn
                  color="primary"
                  :disabled="!selectedEndDate"
                  @click="navigate(data)"
                  id="search-date"
                >
                  Search
                </v-btn>
              </div>
            </div>
          </date-range-picker>
        </div>
      </div>

      <div class="search-container">
      </div>

      <div class="search-container">
      </div>

      <div class="search-container">
      </div>
    </div>
    <div class="search-button mt-5">
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "../../modules/axios";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { mapGetters } from "vuex";
const currentDate = new Date(
  Date.now() - new Date().getTimezoneOffset() * 60000
)
  .toISOString()
  .substr(0, 10);
export default {
  components: { DateRangePicker },
  props: {
    margin: {
      type: String,
      default: "0",
    },
    mobileOnly: {
      type: Boolean,
      required: false,
      default: true,
    },
    vehicleId: {
      type: [String, Number],
      required: false,
      default: "",
    },
    id: {
      type: [String, Number],
      required: false,
      default: "",
    },
  },
  data: () => ({
    activeMonth: null,
    numOfDays: 30,
    selectedStartDate: null,
    selectedEndDate: null,
    dateRange: {
      start: currentDate,
      end: currentDate,
    },
    loading: false,
    occupiedDays: [],
    isVisible: false,
    pickupTime: "09:00 AM",
    returnTime: "09:00 AM",
    disabled: [],
    date: new Date(),
    returnDate: [currentDate, currentDate],
    locations: [
      {
        name: "Seattle", // - 747 South Monroe Street, Seattle, WASHINGTON, USA',
        id: "s1",
      },
    ],
    dropTimes: [
      {
        name: "09:00 AM",
        id: "p1",
      },
      {
        name: "09:15 AM",
        id: "p2",
      },
      {
        name: "09:30 AM",
        id: "p3",
      },
      {
        name: "09:45 AM",
        id: "p4",
      },
      {
        name: "10:00 AM",
        id: "p5",
      },
      {
        name: "10:15 AM",
        id: "p6",
      },
      {
        name: "10:30 AM",
        id: "p7",
      },
      {
        name: "10:45 AM",
        id: "p8",
      },
      {
        name: "11:00 AM",
        id: "p9",
      },
    ],
    pickupTimes: [
      {
        name: "09:00 AM",
        id: "p1",
      },
      {
        name: "09:30 AM",
        id: "p2",
      },
      {
        name: "10:00 AM",
        id: "p3",
      },
      {
        name: "10:30 AM",
        id: "p4",
      },
      {
        name: "11:00 AM",
        id: "p5",
      },
      {
        name: "11:30 AM",
        id: "p6",
      },
      {
        name: "12:00 PM",
        id: "p7",
      },
      {
        name: "12:30 PM",
        id: "p8",
      },
      {
        name: "01:00 PM",
        id: "p9",
      },
      {
        name: "01:30 PM",
        id: "p10",
      },
      {
        name: "02:00 PM",
        id: "p11",
      },
      {
        name: "02:30 PM",
        id: "p12",
      },
      {
        name: "03:00 PM",
        id: "p13",
      },
      {
        name: "03:30 PM",
        id: "p14",
      },
      {
        name: "04:00 PM",
        id: "p15",
      },
    ],
  }),
  computed: {
    getMinDate() {
      return new Date(moment().add("day", 1).format("MMM-DD-YYYY"));
    },
    startDate() {
      return this.dateRange?.startDate
        ? moment(this.selectedStartDate).format("MMM-DD-YYYY")
        : "";
    },
    endDate() {
      return this.dateRange?.endDate
        ? moment(this.selectedEndDate).format("MMM-DD-YYYY")
        : "";
    },
    ...mapGetters({
      user: "getUser",
    }),
    getClass() {
      return !this.mobileOnly ? "search show" : "search";
    },
    getQuery() {
      return `?start=${this.startDate}&end=${this.endDate}`;
    },
  },
  mounted() {
    this.connectToServer();
    const { start, end, pickup, drop } = this.$route.query;
    if (start) {
      this.dateRange = { startDate: start, endDate: end };
    }
    if (pickup) {
      this.pickupTime = pickup;
      this.returnTime = drop;
    }
  },
  methods: {
    navigate(data) {
      data?.clickApply?.();
      const start = moment(this.selectedStartDate).utc().valueOf();
      const end = moment(this.selectedEndDate).utc().valueOf();

      // check in start date is grater than end date so convert it to end date
      if (start > end) {
        let endDate = this.selectedStartDate;
        this.selectedStartDate = this.selectedEndDate;
        this.selectedEndDate = endDate;
      }

      if (start === end) {
        this.$root.toast("Please select a valid date range", "error");
        return;
      }

      if (!this.startDate) {
        this.$root.toast("Please select a valid date range", "error");
        return;
      }

      const diff = moment(this.selectedStartDate).diff(
        moment(this.selectedEndDate),
        "days"
      );
      
      if (Math.abs(diff) > 30) {
        this.$root.toast(
          "You can't book more than 30 consecutive days",
          "warning"
        );
        return;
      }

      if (!this.mobileOnly) {
        if (!this.user?.uid) {
          const query = `${this.getQuery}&redirect=vehicles/${this.id}`;
          this.$router.push("/login" + query);
          return;
        }
        this.$router.push(
          `vehicles/${this.vehicleId}?start=${this.startDate || ""}&end=${
            this.endDate || ""
          }&pickup=${this.pickupTime || ""}&drop=${this.returnTime || ""}`
        );
        return;
      }

      this.$router.push(
        `/vehicles?start=${this.startDate || ""}&end=${
          this.endDate || ""
        }&pickup=${this.pickupTime || ""}&drop=${this.returnTime || ""}`
      );
    },
    connectToServer() {
      this.loading = true;
      axios
        .get("/check-inventory")
        .then((response) => {
          this.occupiedDays = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onStartSelection(date) {
      this.selectedStartDate = moment(date).format("YYYY-MM-DD");
      this.selectedEndDate = null;
      this.dateRange.startDate = moment(date).format("YYYY-MM-DD");
    },
    onFinishSelection(date) {
      this.selectedEndDate = moment(date).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(date).format("YYYY-MM-DD");
    },
    formatDate(date) {
      const formattedDate = moment(date).format("DD");
      const month = moment(date).format("MM");
      const day = moment(date).format("ddd");
      if (month == this.activeMonth) {
        // below code will run for members only
        if (!this.user?.member) {
          return `<span class="d-flex justify-content-center flex-column align-center">
            ${formattedDate}
          </span>`;
        }

        const allowesDays = this.user?.plan?.allowed_days || "";

        if (!this.selectedStartDate) {
          return `<span class="d-flex justify-content-center flex-column align-center">
            ${formattedDate}
          </span>`;
        }
        // add 10 days to the date
        const credit_days = this.user?.credit_days ?? 0
        const newDate = moment(moment(this.selectedStartDate).subtract("day", 1))
          .add(credit_days, "days")
          .format("YYYY-MM-DD");
        const allDates = enumerateDaysBetweenDates(
          this.selectedStartDate,
          newDate
        );
        if (
          moment(this.selectedStartDate).format("YYYY-MM-DD") >=
          moment(date).format("YYYY-MM-DD")
        ) {
          return `<span class="d-flex justify-content-center flex-column align-center">
            ${formattedDate}
          </span>`;
        }
        const match = allDates.find(
          (day) => moment(date).format("YYYY-MM-DD") === day
        );
        if (match) {
          const checkDaysArray = allowesDays.split(",");
          if ( !checkDaysArray.includes(day.toUpperCase()) ) {
            return `<span class="d-flex justify-content-center flex-column align-center">
              ${formattedDate}<div class='small-text'>$87.5</div>
            </span>`;
          }
          return `<span class="d-flex justify-content-center flex-column align-center">
            ${formattedDate}<div class='small-text'>$0</div>
          </span>`;
        }
        return `<span class="d-flex justify-content-center flex-column align-center">
          ${formattedDate}
          ${!match ? "<div class='small-text'>$87.5</div>" : ""}</span>`;
      } else {
        return "";
      }
    },
    dateFormat(classes, date) {
      let match = null
      this.occupiedDays.forEach((day) => {
        const formatted = moment(date).format("YYYY-MM-DD")
        const isMatch = moment(day.startDate).utc().valueOf() === moment(formatted).utc().valueOf();
        if (isMatch) {
          match = day;
        }
      });

      if (match) {
        const isDisabled = match.totalBookings >= match.totalInventory ? false : true;
        if (!classes.disabled) {
          classes.disabled = !isDisabled;
        }
      }

      const month = moment(date).format("MM");
      if (month != this.activeMonth) {
        classes.disabled = true;
      }

      return classes;
    },
    formatFullDate() {
      return (
        moment(this.dateRange.startDate).format("MMM-DD-YYYY") +
        " - " +
        moment(this.dateRange.endDate).format("MMM-DD-YYYY")
      );
    },
    onChangeMonth(date) {
      this.activeMonth = moment(date).format("MM");
      const year = moment(date).format("YYYY");
      if (this.activeMonth == 1) {
        this.numOfDays = 31;
      }
      /// is leap year
      if (this.activeMonth == 2) {
        if (year % 4 == 0) {
          this.numOfDays = 29;
        } else {
          this.numOfDays = 28;
        }
      }
      if (this.activeMonth == 3) {
        this.numOfDays = 31;
      }
      if (this.activeMonth == 4) {
        this.numOfDays = 30;
      }
      if (this.activeMonth == 5) {
        this.numOfDays = 31;
      }
      if (this.activeMonth == 6) {
        this.numOfDays = 30;
      }
      if (this.activeMonth == 7) {
        this.numOfDays = 31;
      }
      if (this.activeMonth == 8) {
        this.numOfDays = 31;
      }
      if (this.activeMonth == 9) {
        this.numOfDays = 30;
      }
      if (this.activeMonth == 10) {
        this.numOfDays = 31;
      }
      if (this.activeMonth == 11) {
        this.numOfDays = 30;
      }
      if (this.activeMonth == 12) {
        this.numOfDays = 31;
      }
    },
    onToggle(state) {
      if ( !state ) {
        if ( !this.selectedStartDate || !this.selectedEndDate ) {
          this.selectedStartDate = null;
          this.selectedEndDate = null;
        }
      }
    },
  },
};

const enumerateDaysBetweenDates = function (startDate, endDate) {
  const dates = [];

  const currDate = moment(startDate).startOf("day");
  const lastDate = moment(endDate).startOf("day");

  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    let date = moment(currDate).format("YYYY-MM-DD");
    dates.push(date);
    // moment(dates.push(currDate.clone().toDate())).format("YYYY-MM-DD");
  }
  dates.push(endDate);

  return dates;
};
</script>

<style scoped lang="scss">
.show {
  display: flex !important;
}
.search {
  position: relative;
  z-index: 10;
  max-width: 895px;
  height: 85px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
  padding: 0 40px;
  backdrop-filter: blur(4px);
  box-shadow: 10px 10px 74px -14px rgba(0, 0, 0, 0.75);
  display: none;
  align-items: center;
  column-gap: 10px;
  &-location {
    display: flex;
    column-gap: 20px;
  }
  &-seprator {
    width: 0;
    height: 70%;
    border: 0.5px solid var(--grey);
  }
  &-container {
    font-size: 14px;
    cursor: pointer;
  }
  &-textbox {
    display: flex;
    align-items: center;
    column-gap: 7px;
    // margin-top: 5px;
    background: var(--light);
    padding: 2px 10px;
    border-radius: 5px;
    white-space: nowrap;
  }
  &-box-label {
    color: var(--primary-color);
    white-space: nowrap;
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &-dates {
    display: flex;
    column-gap: 10px;
  }
  &-button {
    // margin-left: 20px;
    flex-grow: 1;
    // background: var(--red-color);
  }
  &-label {
    color: var(--secondary-color);
    font-weight: 600;
    font-size: 16px;
    white-space: nowrap;
  }
}
.calender {
  padding: 3px;
  border-radius: 3px;
  &-attr {
    font-size: 10px;
  }
}
@media screen and (max-width: 568px) {
  .search {
    min-width: 100%;
  }
}
@media screen and (max-width: 800px) {
  .search {
    display: flex;
  }
}
</style>
<style>
.calendars {
  justify-content: center;
}
.free {
  width: 6px;
  height: 6px;
  background: green;
  border-radius: 10px;
}
.paid {
  width: 6px;
  height: 6px;
  background: red;
  border-radius: 10px;
}
.daterangepicker {
  min-width: 100% !important;
}
.show-ranges {
  min-width: 100% !important;
}
@media screen and (min-width: 768px) {
  .daterangepicker {
    min-width: 100% !important;
  }
  .show-ranges {
    min-width: 100% !important;
  }
}
</style>